import {
  FetchPcsNotificationsSuccess,
  PcsNotificationsActions,
  PcsNotificationsActionsTypes
} from '@app/pcs/shared/notifications/store/actions/notifications-actions';
import { createHandler, createReducer } from '@util';
import * as R from 'ramda';

export interface PcsNotifications {
  notSeenFeatures: number;
}

export interface State {
  pcsNotifications: PcsNotifications;
}

export const initialState = {
  pcsNotifications: null
};

type GetPcsNotifications = (state: State) => PcsNotifications;
const getPcsNotifications: GetPcsNotifications = R.prop('pcsNotifications');

type GetNotSeenNewFeatures = (state: State) => number;
export const getNotSeenNewFeatures: GetNotSeenNewFeatures = R.compose(R.prop('notSeenFeatures'), getPcsNotifications);

const fetchPcsNotificationsSuccess = (state: State, action: FetchPcsNotificationsSuccess) => R.mergeRight(state, {
  pcsNotifications: action.payload
});

const increaseNotSeenNewFeatures = (state: State) => R.mergeRight(state, {
  pcsNotifications: {
    notSeenFeatures: R.inc(getNotSeenNewFeatures(state))
  }
});

const decreaseNotSeenNewFeatures = (state: State) => R.mergeRight(state, {
  pcsNotifications: {
    notSeenFeatures: R.dec(getNotSeenNewFeatures(state))
  }
});

const fetchFeaturesSuccessHandler = createHandler(PcsNotificationsActionsTypes.FetchNotificationsSuccess, fetchPcsNotificationsSuccess);
const increaseNotSeenNewFeatureNumberHandler = createHandler(PcsNotificationsActionsTypes.IncreaseNotSeenNewFeatureNumber, increaseNotSeenNewFeatures);
const decreaseNotSeenNewFeaturesNumberHandler = createHandler(PcsNotificationsActionsTypes.DecreaseNotSeenNewFeatureNumber, decreaseNotSeenNewFeatures);

export const reducer = createReducer<State, PcsNotificationsActions>([
  fetchFeaturesSuccessHandler,
  increaseNotSeenNewFeatureNumberHandler,
  decreaseNotSeenNewFeaturesNumberHandler], initialState);
